var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-service 1",
    clipPath: "url(#clip0_514_5683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3087",
    d: "M1.17188 13.5894C1.17188 6.6705 6.83062 1.07315 13.7723 1.17315C20.4966 1.26987 25.9642 6.7844 26.0067 13.5091C26.0306 17.2752 24.3775 20.6552 21.7505 22.9477C21.4733 23.1896 21.5133 23.6313 21.8298 23.8185L24.1697 25.203C24.5478 25.4267 24.3892 26.0067 23.9495 26.0066L13.3544 26.0039C6.60484 25.8785 1.17188 20.3688 1.17188 13.5894Z",
    fill: "#7ACAA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3091",
    d: "M24.1695 25.2031L21.8297 23.8187C21.5148 23.6323 21.4709 23.1914 21.7469 22.9509C24.4037 20.6339 26.0656 17.2048 26.0053 13.3889C25.9011 6.78809 20.5587 1.36965 13.9598 1.17731C13.0241 1.15012 12.1108 1.22668 11.2305 1.3959C16.9344 2.48934 21.2814 7.51699 21.3192 13.5093C21.3375 16.4112 20.36 19.084 18.7086 21.2068C17.7114 22.4886 18.0355 24.3471 19.4333 25.1742L19.482 25.2031C19.8562 25.4245 19.7045 25.9932 19.2759 26.0056L23.9495 26.0068C24.3891 26.0068 24.5478 25.427 24.1695 25.2031Z",
    fill: "#57BE92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3095",
    d: "M61.6764 46.2446H33.5069C26.4711 46.2446 22.621 38.0453 27.1145 32.6313L27.3644 32.3304C29.3441 29.9454 30.4277 26.9432 30.4277 23.8437V18.4113C30.4277 8.89025 38.1461 1.17181 47.6674 1.17181C57.1884 1.17181 64.907 8.89025 64.907 18.4113V24.027C64.907 27.159 66.0134 30.1904 68.0308 32.5862C72.5806 37.989 68.7399 46.2446 61.6764 46.2446Z",
    fill: "#C59191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3099",
    d: "M76.4845 78.8281V60.2053C76.4845 56.092 74.0597 52.3653 70.2991 50.6989L57.682 45.2911C55.2823 44.2625 53.7266 41.903 53.7266 39.2922V38.1492H41.4572V39.3544C41.4572 41.9528 39.9159 44.3038 37.533 45.3399L25.0636 50.7613C21.2072 52.3844 18.6992 56.1608 18.6992 60.345V78.8281",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3103",
    d: "M34.3906 51.1461C37.5742 52.0974 42.2605 53.1121 47.9725 53.0122C53.3322 52.9186 57.7317 51.8764 60.793 50.8988L62.3141 47.2764L57.6819 45.2911C55.2822 44.2625 53.7264 41.903 53.7264 39.2922V38.1493H41.4573V39.3544C41.4573 41.9529 39.9158 44.3038 37.5328 45.3399L33.7812 46.971L34.3906 51.1461Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3107",
    d: "M70.2989 50.6989L60.7947 46.6253L60.793 46.6255V78.8281H76.4844V60.2053C76.4844 56.092 74.0595 52.3653 70.2989 50.6989Z",
    fill: "#8795DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3111",
    d: "M24.8847 50.6989L34.3891 46.6253L34.3908 46.6255V78.8281H18.6992V60.2053C18.6992 56.092 21.1241 52.3653 24.8847 50.6989Z",
    fill: "#8795DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3115",
    d: "M51.078 35.6499H48.3318C47.0818 35.6499 46.0684 34.6366 46.0684 33.3866C46.0684 32.1366 47.0818 31.1232 48.3318 31.1232H51.078C52.328 31.1232 53.3413 32.1366 53.3413 33.3866C53.3413 34.6366 52.328 35.6499 51.078 35.6499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3119",
    d: "M51.078 35.6499H48.3318C47.0818 35.6499 46.0684 34.6366 46.0684 33.3866C46.0684 32.1366 47.0818 31.1232 48.3318 31.1232H51.078C52.328 31.1232 53.3413 32.1366 53.3413 33.3866C53.3413 34.6366 52.328 35.6499 51.078 35.6499Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3123",
    d: "M48.7242 59.4904C48.7242 60.1154 48.2175 60.6221 47.5925 60.6221C46.9675 60.6221 46.4609 60.1154 46.4609 59.4904C46.4609 58.8654 46.9675 58.3586 47.5925 58.3586C48.2175 58.3586 48.7242 58.8654 48.7242 59.4904Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3127",
    d: "M51.8438 44.8833C53.2554 44.8833 54.6004 44.5999 55.8265 44.0883C54.5113 42.8744 53.7255 41.1469 53.7255 39.2922V38.1492H41.4565V39.3544C41.4565 40.2931 41.2543 41.1991 40.8848 42.0228C42.7427 43.7938 45.2562 44.8833 48.0255 44.8833H51.8438Z",
    fill: "#FFB09E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3131",
    d: "M59.8554 19.6924V29.8422C59.8554 35.5603 55.2199 40.1958 49.5018 40.1958H45.6835C39.9654 40.1958 35.3301 35.5603 35.3301 29.8422V19.6924C35.3301 15.9725 38.3455 12.9569 42.0655 12.9569H53.1199C56.8398 12.9569 59.8554 15.9725 59.8554 19.6924Z",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3135",
    d: "M51.078 35.6499H48.3318C47.0818 35.6499 46.0684 34.6366 46.0684 33.3866C46.0684 32.1366 47.0818 31.1232 48.3318 31.1232H51.078C52.328 31.1232 53.3413 32.1366 53.3413 33.3866C53.3413 34.6366 52.328 35.6499 51.078 35.6499Z",
    fill: "#685E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3139",
    d: "M50.0391 10.2704C50.302 6.95402 53.477 4.75308 56.5156 3.6134C61.5425 6.62527 64.9077 12.1251 64.9077 18.4114V19.5967C64.6297 19.655 64.3531 19.7061 64.0798 19.7468C62.4058 19.9968 60.9802 19.8887 60.0064 19.7468C53.7305 18.9107 49.7216 14.2757 50.0391 10.2704Z",
    fill: "#B98080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3143",
    d: "M47.6674 1.17183C51.5609 1.17183 55.1523 2.46308 58.0384 4.6398C56.5987 7.14495 53.2929 12.0978 47.0938 15.7646C42.492 18.4867 38.1527 19.4014 35.4805 19.7468H30.4277V18.4114C30.4277 8.89026 38.1462 1.17183 47.6674 1.17183Z",
    fill: "#C59191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3147",
    d: "M66.9394 78.8281H29.4261L27.3571 59.3097C27.2102 57.9252 28.2955 56.7188 29.6877 56.7188H66.6779C68.07 56.7188 69.1554 57.9252 69.0085 59.3097L66.9394 78.8281Z",
    fill: "#EFEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3151",
    d: "M66.6777 56.7188H61.9902C63.3824 56.7188 64.4676 57.9252 64.3209 59.3095L62.2518 78.8281H66.9393L69.0084 59.3095C69.1551 57.9252 68.0699 56.7188 66.6777 56.7188Z",
    fill: "#E5E1E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3155",
    d: "M78.8281 80H1.17187C0.524531 80 0 79.4753 0 78.8281C0 78.1809 0.524531 77.6562 1.17187 77.6562H78.8281C79.4755 77.6562 80 78.1809 80 78.8281C80 79.4753 79.4755 80 78.8281 80Z",
    fill: "#C9BFC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3159",
    d: "M51.4629 67.7734C51.4629 69.5856 49.994 71.0547 48.1816 71.0547C46.3695 71.0547 44.9004 69.5856 44.9004 67.7734C44.9004 65.9613 46.3695 64.4922 48.1816 64.4922C49.994 64.4922 51.4629 65.9613 51.4629 67.7734Z",
    fill: "#C9BFC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3163",
    d: "M1.17188 13.5894C1.17188 6.6705 6.83062 1.07315 13.7723 1.17315C20.4966 1.26987 25.9642 6.7844 26.0067 13.5091C26.0306 17.2752 24.3775 20.6552 21.7505 22.9477C21.4733 23.1896 21.5133 23.6313 21.8298 23.8185L24.1697 25.203C24.5478 25.4267 24.3892 26.0067 23.9495 26.0066L13.3544 26.0039C6.60484 25.8785 1.17188 20.3688 1.17188 13.5894Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3167",
    d: "M59.9097 46.2451H61.677C66.6317 46.2451 70.0003 42.1826 70.0003 37.8936C70.0003 36.067 69.3894 34.1998 68.0316 32.5857C66.0144 30.1904 64.9081 27.1592 64.9081 24.0264V18.4107C64.9081 13.6498 62.9784 9.34044 59.8581 6.22169C56.7378 3.10138 52.4284 1.17169 47.6675 1.17169C38.1472 1.17169 30.4284 8.89044 30.4284 18.4107V23.8436C30.4284 26.9436 29.3441 29.9451 27.3644 32.3311L27.1144 32.6311C22.6206 38.0451 26.4722 46.2451 33.5067 46.2451H35.4488",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3171",
    d: "M18.6992 74.1406V60.3453C18.6992 56.1609 21.207 52.3844 25.0648 50.7609L35.4492 46.2453L37.5336 45.3391C39.9164 44.3031 41.4586 41.9531 41.4586 39.3547V39.2969",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3175",
    d: "M53.7266 39.2969C53.7283 41.9063 55.2845 44.2625 57.6814 45.2906L59.9094 46.2453L70.2986 50.6984C74.0595 52.3656 76.4844 56.0922 76.4844 60.2047V78.8281",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3179",
    d: "M60.793 56.7188V46.625",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3183",
    d: "M34.3906 56.7188V46.7062",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3187",
    d: "M34.3906 51.1461C37.5742 52.0974 42.2605 53.1121 47.9725 53.0122C53.3322 52.9186 57.7317 51.8763 60.7931 50.8988",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3191",
    d: "M59.8551 19.725V29.8422C59.8551 35.5609 55.2191 40.1953 49.5018 40.1953H45.6832C39.9643 40.1953 35.3301 35.5609 35.3301 29.8422V19.7469",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3195",
    d: "M59.8536 27.317C59.4958 28.2266 58.6537 29.9986 56.8244 31.5077C55.5094 32.5923 54.193 33.1214 53.3398 33.3867",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3199",
    d: "M51.078 35.6499H48.3318C47.0818 35.6499 46.0684 34.6366 46.0684 33.3866C46.0684 32.1366 47.0818 31.1232 48.3318 31.1232H51.078C52.328 31.1232 53.3413 32.1366 53.3413 33.3866C53.3413 34.6366 52.328 35.6499 51.078 35.6499Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3203",
    d: "M53.6445 17.1656C55.2708 18.4256 57.3833 19.3706 59.8545 19.7251C59.9044 19.7329 59.9545 19.7406 60.0061 19.747C60.9794 19.8892 62.4044 19.997 64.0795 19.747C64.353 19.7064 64.6295 19.6548 64.9077 19.597",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3207",
    d: "M58.0384 4.63988C56.5987 7.14504 53.2929 12.0979 47.0938 15.7647C42.492 18.4869 38.1527 19.4016 35.4805 19.7471H30.4277",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3211",
    d: "M29.4261 78.8281L27.3571 59.3097C27.2102 57.9252 28.2955 56.7188 29.6877 56.7188H66.6779C68.0701 56.7188 69.1554 57.9252 69.0085 59.3097L66.9394 78.8281",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3215",
    d: "M1.17188 78.8281H78.8281",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3219",
    d: "M51.4629 67.7734C51.4629 69.5856 49.994 71.0547 48.1816 71.0547C46.3695 71.0547 44.9004 69.5856 44.9004 67.7734C44.9004 65.9613 46.3695 64.4922 48.1816 64.4922C49.994 64.4922 51.4629 65.9613 51.4629 67.7734Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3223",
    d: "M10.0742 13.5894C10.0742 14.2365 9.54953 14.7612 8.90234 14.7612C8.255 14.7612 7.73047 14.2365 7.73047 13.5894C7.73047 12.9422 8.255 12.4175 8.90234 12.4175C9.54953 12.4175 10.0742 12.9422 10.0742 13.5894Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3227",
    d: "M14.7617 13.5894C14.7617 14.2365 14.237 14.7612 13.5898 14.7612C12.9425 14.7612 12.418 14.2365 12.418 13.5894C12.418 12.9422 12.9425 12.4175 13.5898 12.4175C14.237 12.4175 14.7617 12.9422 14.7617 13.5894Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3231",
    d: "M19.4492 13.5894C19.4492 14.2365 18.9245 14.7612 18.2773 14.7612C17.63 14.7612 17.1055 14.2365 17.1055 13.5894C17.1055 12.9422 17.63 12.4175 18.2773 12.4175C18.9245 12.4175 19.4492 12.9422 19.4492 13.5894Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_5683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaller);
export default __webpack_public_path__ + "static/media/caller.96ab2c72d23382913f9d4cd2bb4f553b.svg";
export { ForwardRef as ReactComponent };